import { jsxs as t, Fragment as l, jsx as o } from "react/jsx-runtime";
import { FireFlameCurved as p, ChevronRight as m } from "@pelando/fontawesome/icons";
import { Image as P } from "../Image/index.js";
import { getPriceString as f } from "../../services/strings/index.js";
import { Icon as i } from "../Icon/index.js";
import { useTranslation as d } from "../../hooks/useTranslation/index.js";
import { ContainerV2 as I, GradientBorder as g, HotTag as h, Container as S, ImageWrapper as N, TitleWrapper as b, PriceWrapper as v, PriceContainer as V, StoresContainer as F, IconContainer as u, StoresContainerV2 as G, MobileStoresCount as W } from "./style.js";
const s = ({
  isHotPrice: r,
  children: n,
  ...e
}) => {
  const { t: c } = d("common");
  return /* @__PURE__ */ t(I, { ...e, children: [
    r && /* @__PURE__ */ t(l, { children: [
      /* @__PURE__ */ o(g, { className: "gradient-border" }),
      /* @__PURE__ */ t(h, { className: "hot-tag", children: [
        /* @__PURE__ */ o(i, { icon: p }),
        c("grid-product-card-hot-tag")
      ] })
    ] }),
    n
  ] });
}, a = ({
  isHotPrice: r,
  children: n,
  ...e
}) => {
  const { t: c } = d("common");
  return /* @__PURE__ */ t(S, { ...e, children: [
    r && /* @__PURE__ */ t(l, { children: [
      /* @__PURE__ */ o(g, {}),
      /* @__PURE__ */ t(h, { children: [
        /* @__PURE__ */ o(i, { icon: p }),
        c("grid-product-card-hot-tag")
      ] })
    ] }),
    n
  ] });
}, C = (r) => /* @__PURE__ */ o(N, { className: "image", children: /* @__PURE__ */ o(P, { ...r, role: "presentation" }) }), x = (r) => /* @__PURE__ */ o(b, { className: "title", ...r }), T = ({ value: r, ...n }) => {
  const { t: e } = d("common"), c = f(r);
  return /* @__PURE__ */ t(v, { ...n, children: [
    /* @__PURE__ */ o("span", { children: e("grid-product-card-price-text") }),
    /* @__PURE__ */ t(V, { children: [
      e("grid-product-card-price"),
      " ",
      /* @__PURE__ */ o("span", { children: c })
    ] })
  ] });
}, j = ({ count: r, ...n }) => {
  const { t: e } = d("common"), c = r === 1 ? "grid-product-card-stores-singular" : "grid-product-card-stores";
  return /* @__PURE__ */ t(F, { ...n, children: [
    /* @__PURE__ */ t("div", { children: [
      e("grid-product-card-stores-text"),
      /* @__PURE__ */ t("b", { children: [
        r,
        " ",
        e(c)
      ] })
    ] }),
    /* @__PURE__ */ o(u, { children: /* @__PURE__ */ o(i, { icon: m }) })
  ] });
}, B = ({ count: r, ...n }) => {
  const { t: e } = d("common"), c = r === 1 ? "grid-product-card-stores-singular" : "grid-product-card-stores";
  return /* @__PURE__ */ t(G, { ...n, children: [
    /* @__PURE__ */ t("div", { className: "stores-count-text", children: [
      e("grid-product-card-stores-text"),
      /* @__PURE__ */ t("b", { children: [
        r,
        " ",
        e(c)
      ] })
    ] }),
    /* @__PURE__ */ t(W, { children: [
      e("grid-product-card-stores-text"),
      " ",
      r,
      " ",
      e(c),
      /* @__PURE__ */ o(i, { icon: m })
    ] }),
    /* @__PURE__ */ o(u, { className: "icon-container", children: /* @__PURE__ */ o(i, { icon: m }) })
  ] });
};
a.Image = C;
a.Title = x;
a.Price = T;
a.Stores = j;
s.Image = C;
s.Title = x;
s.Price = T;
s.Stores = B;
export {
  a as GridProductCard,
  s as GridProductCardV2
};
